import {
  getFromLocalStorage,
  setToLocalStorage,
  parseQueryString,
  removeFromLocalStorage,
} from './util';
import { ChannelCacheKey, DefaultChannel, NSFWCacheKey, NsfwFlag } from '../config';

const AppChannel = (function () {
  const { cid, pid, nsfw } = parseQueryString(window.location.search);
  const ocid = getFromLocalStorage(ChannelCacheKey);
  const c = cid || pid || ocid || DefaultChannel;
  if (c !== ocid) {
    removeFromLocalStorage(NSFWCacheKey);
    setToLocalStorage(ChannelCacheKey, c);
  }
  const onsfw = getFromLocalStorage(NsfwFlag);
  if (nsfw && nsfw !== onsfw) {
    setToLocalStorage(NsfwFlag, nsfw);
  }
  return c;
})();

export default AppChannel;
